import type { WebsiteStatus } from '../types/api';

export const REVISION_SECTIONS = [
  'Hero',
  'About',
  'Services',
  'Gallery',
  'Testimonials',
  'Contact',
  'Footer',
  'Navigation',
  'Multiple sections',
  'Whole page',
] as const;

export type RevisionSection = (typeof REVISION_SECTIONS)[number];

// Options for Select component
export const SECTION_OPTIONS = REVISION_SECTIONS.map((section) => ({
  value: section,
  label: section,
}));

export const STATUS_LABELS: Record<WebsiteStatus, string> = {
  pending: 'Pending',
  generating: 'Generating',
  'pending-tech-qa': 'Tech QA',
  'tech-qa-failed': 'Tech QA Failed',
  'pending-internal-qa': 'Internal QA',
  'needs-internal-revision': 'Needs Revision',
  'pending-customer-review': 'Customer Review',
  'needs-customer-revision': 'Customer Revision',
  'approved-to-launch': 'Approved to Launch',
  active: 'Active',
  live: 'Live',
  suspended: 'Suspended',
  'generation-failed': 'Generation Failed',
};

export const STATUS_COLORS: Record<
  WebsiteStatus,
  { bg: string; text: string; dot: string }
> = {
  pending: { bg: 'bg-gray-100', text: 'text-gray-800', dot: 'bg-gray-500' },
  generating: { bg: 'bg-blue-100', text: 'text-blue-800', dot: 'bg-blue-500' },
  'pending-tech-qa': {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    dot: 'bg-yellow-500',
  },
  'tech-qa-failed': {
    bg: 'bg-red-100',
    text: 'text-red-800',
    dot: 'bg-red-500',
  },
  'pending-internal-qa': {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    dot: 'bg-yellow-500',
  },
  'needs-internal-revision': {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    dot: 'bg-orange-500',
  },
  'pending-customer-review': {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    dot: 'bg-blue-500',
  },
  'needs-customer-revision': {
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    dot: 'bg-orange-500',
  },
  'approved-to-launch': {
    bg: 'bg-purple-100',
    text: 'text-purple-800',
    dot: 'bg-purple-500',
  },
  active: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    dot: 'bg-green-500',
  },
  live: {
    bg: 'bg-green-100',
    text: 'text-green-800',
    dot: 'bg-green-500',
  },
  suspended: { bg: 'bg-gray-100', text: 'text-gray-800', dot: 'bg-gray-500' },
  'generation-failed': {
    bg: 'bg-red-100',
    text: 'text-red-800',
    dot: 'bg-red-500',
  },
};
